import { gql } from "@apollo/client";

export type PricingFactorOption = {
  id: string;
  sheetType: string;
  label: string;
  factor: number;
  enabled: boolean;
};

export type GetPricingFactorsQueryVariables = {};

export type GetPricingFactorsQueryData = {
  getPricingFactors: PricingFactorOption[];
};

// The pricing sheets that can be applied to an estimation. The same query the pricing management
// grid reads; each screen keeps the ones it is interested in — here, the enabled ones.
export const GET_PRICING_FACTORS = gql`
  query PricingFactors {
    getPricingFactors {
      id
      sheetType
      label
      factor
      enabled
    }
  }
`;

export type GetPricingEstimationMutationVariables = {
  gIAColor: string | null;
  langermanColor: string | null;
  flatColor: string | null;
  meleeColor: string | null;
  clarity: string;
  carat: number;
  pricingFactorIds: string[];
};

export type EquivalentColorsSet = {
  system: string;
  // the color that was queried
  color: string;
  // the colors confirmed equivalent to it, the queried color itself left out
  equivalentColors: string[];
};

export type GetPricingEstimationMutationData = {
  estimateDiamondPrice: {
    schemesPercentiles: {
      percentiles: number[];
      // both names the scheme and widens it: system + color are the color that was queried, and
      // its equivalent colors are what else contributed stones to these percentiles
      equivalentColors: EquivalentColorsSet;
    }[];
    similarDiamonds: {
      iD: string;
      sKU: string;
      source: string;
      representationImageID: string | null;
      color: string;
      langermanColor: string | null;
      flat: number | null;
      melee: number | null;
      clarity: string;
      carat: number;
      price: number;
      perCarat: number;
      perCaratNormalized: number;
      tags: string;
      matchingScore: number;
    }[];
  };
};

export const GET_PRICING_ESTIMATION = gql`
  mutation GetPricingEstimation(
    $gIAColor: String
    $langermanColor: String
    $flatColor: String
    $meleeColor: String
    $clarity: String!
    $carat: Float!
    $pricingFactorIds: [ID!]!
  ) {
    estimateDiamondPrice(
      gIAColor: $gIAColor
      langermanColor: $langermanColor
      flatColor: $flatColor
      meleeColor: $meleeColor
      clarity: $clarity
      carat: $carat
      pricingFactorIds: $pricingFactorIds
    ) {
      schemesPercentiles {
        percentiles
        equivalentColors {
          system
          color
          equivalentColors
        }
      }
      similarDiamonds {
        iD
        sKU
        source
        representationImageID
        color
        langermanColor
        flat
        melee
        clarity
        carat
        price
        perCarat
        perCaratNormalized
        tags
        matchingScore
      }
    }
  }
`;
